<template>
  <div class="vld-parent">
    <loading
      :active.sync="isLoading"
      :z-index="2000"
    >
      <div class="loader" />
    </loading>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Indicator from '@/lib/indicator'
export default {
  components: {
    Loading
  },
  computed: {
    isLoading () {
      return Indicator.getLoadingStatus()
    }
  }
}
</script>
